import { AvatarConfig } from './config/AvatarConfig';
import moment from 'moment';
import { LogoConfig } from './config/LogoConfig';

/** @mixes CONFIG_STATIC_URLS_KEYS */
var Config = function () {

  var SERVER_DATE_KEY = "serverDate",
    LANG_LIST_KEY = "availablesLanguages",
    RTL_LANG_LIST_KEY = "rtlLanguages";

  var self = this;

  var serverParamsString = "{}";

  var parseConfigParams = function (params) {
    serverParamsString = params;
    var serverConfig = JSON.parse(params);
    for (var i in serverConfig) {
      if (!serverConfig.hasOwnProperty(i)) continue;

      if (i === SERVER_DATE_KEY) {
        self[i] = moment(serverConfig[i]);
        continue;
      }

      if (i === LANG_LIST_KEY || i === RTL_LANG_LIST_KEY) {
        self[i] = serverConfig[i].split(',');
        continue;
      }

      switch (serverConfig[i]) {
        case "true":
          self[i] = true;
          break;
        case "false":
          self[i] = false;
          break;
        default :
          self[i] = serverConfig[i];
      }
    }
  };

  var callPreConfigParams = function () {
    /*TODO: before Api call sync callback*/
  };

  this.serverDate = moment();

  this.rtlLanguages = [];

  this.defaultSessionLifetimeInMs = 30 * 60 * 1000;
  this.defaultObservationEditSessionLifetimeInMs = 4 * 60 * 60 * 1000;

  this.defaultDateFormat = 'DD/MM/YYYY';
  this.defaultTimeFormat = 'HH:mm';
  this.defaultDateTimeFormat = 'DD/MM/YYYY, HH:mm';
  this.dateWithShortMonthNameFormat = 'DD MMM YYYY';

  this.notificationDurationInSeconds = 5;
  /**
   * Duration of a notification for a file starting to download in a separate tab
   */
  this.exportFileNotificationDurationInSeconds = 10;

  this.minSearchQueryLength = 3;

  this.apiConfigUrl = "/configuration";

  this.bookBandChartDisplayLabels = false;

  this.defaultModule = null;

  Object.defineProperty(this, 'configPromise', {
    get: function () {
      return configPromise
    }
  });

  this.apiPath = function (urlPath, args) {
    args = args || [];
    return this.apiBaseUrl + urlPath.format(args);
  };

  this.reportPath = function (urlPath, args) {
    args = args || [];
    return this.reportBaseUrl + urlPath.format(args);
  };

  this.cdnPath = function (urlPath, args) {
    args = args || [];
    return this.cdnBaseUrl + urlPath.format(args);
  };

  this.isRtlLang = function(code) {
    return this.rtlLanguages.indexOf(code) >= 0;
  };

  this.getSessionLifetime = function() {
    return Number(this.sessionLifetime) || this.defaultSessionLifetimeInMs;
  };
  
  this.getObservationEditSessionLifetime = function () {
    return Number(this.observationEditSessionLifetime) || this.defaultObservationEditSessionLifetimeInMs;
  };

  this.avatarConfig = new AvatarConfig();

  this.logoConfig = new LogoConfig();

  var configPromise = new Promise((resolve, reject) => {
    var $dfd = $.get(self.apiConfigUrl);
    $dfd.then(parseConfigParams)
      .then(callPreConfigParams)
      .then(self.logoConfig.loadLogosInfo)
      .then(function () {
        resolve(self);
      }).fail(function () {
      reject.apply(this, arguments);
    });
  });
};

module.exports = new Config();
